<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="users"
      v-loading="listLoading"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      ref="table"
      style="width: 100%"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column
        prop="Name"
        label="姓名"
        width="250"
        :show-overflow-tooltip="true"
        sortable
      ></el-table-column>
      <el-table-column
        prop="Gender"
        label="性别"
        width="150"
        :show-overflow-tooltip="true"
        sortable
      ></el-table-column>
      <el-table-column
        prop="CardId"
        label="身份证"
        width
        sortable
      ></el-table-column>
      <el-table-column
        prop="Phone"
        label="手机号"
        width
        sortable
      ></el-table-column>
      <el-table-column
        prop="Enterprise"
        label="我的企业"
        width="200"
        sortable
      ></el-table-column>
      <el-table-column
        prop="OpenId"
        label="微信唯一标识"
        width
        sortable
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="Picture" label="照片" width sortable>
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px; border-radius: 50px"
            :src="scope.row.Picture"
            :preview-src-list="[scope.row.Picture]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        width="230"
        :formatter="formatCreateTime"
        sortable
      ></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="800px"
      custom-class="edit-dialog"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
        class="edit-form"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="姓名" prop="Name">
              <el-input v-model="editForm.Name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="性别" prop="Gender">
              <el-select
                v-model="editForm.Gender"
                placeholder="请选择性别"
                style="width: 100%"
              >
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="身份证" prop="CardId">
              <el-input
                v-model="editForm.CardId"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="手机号" prop="Phone">
              <el-input v-model="editForm.Phone" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="我的企业" prop="Enterprise">
              <el-input
                v-model="editForm.Enterprise"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="真实名称" prop="RealName">
              <el-input
                v-model="editForm.RealName"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="核销权限" prop="GHKEnable">
              <el-switch
                v-model="editForm.GHKEnable"
                @change="handleGHKEnableChange"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <template v-if="editForm.GHKEnable">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="所属场馆" prop="VenueId">
                <el-select
                  v-model="editForm.VenueId"
                  placeholder="请选择场馆"
                  @change="handleVenueChange"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in venueOptions"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="所属订场" prop="VenueCourtId">
                <el-select
                  v-model="editForm.VenueCourtId"
                  placeholder="请选择订场"
                  :disabled="!editForm.VenueId"
                  @change="handleCourtChange"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in courtOptions"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="角色名" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="Enabled">
          <el-select v-model="addForm.Enabled" placeholder="请选择角色状态">
            <el-option label="激活" :value="true"></el-option>
            <el-option label="禁用" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明" prop="Description">
          <el-input
            v-model="addForm.Description"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetWxUserInfo,
  PutWxUserInfo,
  DeleteWxUserInfo,
} from "../../api/WxUserInfo/WxUserInfo";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  GetVenueDataList,
  GetVenueCourtListData,
} from "../../api/stadium/stadium";

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: "",
      },
      buttonList: [],
      options: [],
      users: [],
      Enabled: true,
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      pageSize: 50,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入角色名", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        Name: "",
        Gender: "",
        CardId: "",
        Phone: "",
        Picture: "",
        Enterprise: "",
        OpenId: "",
        RealName: "",
        GHKEnable: false,
        VenueId: null,
        VenueCourtId: null,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入角色名", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        Name: "",
        AuthorityScope: -1,
        Dids: "",
        Enabled: "",
      },
      isResouceShow: 0,
      srcList: [],
      venueOptions: [], // 场馆选项
      courtOptions: [], // 订场选项
    };
  },
  computed: {
    showTags() {
      return this.editForm.Dids ? this.editForm.Dids.split(",") : [];
    },
  },
  methods: {
    handleCheckChangeAdd(data, checked, indeterminate) {
      this.addForm.Dids = this.addForm.Dids.replace(data.value + ",", "");
      if (checked) {
        this.addForm.Dids += data.value + ",";
      }
      console.log(data, checked, indeterminate);
    },
    handleCheckChangeEdit(data, checked, indeterminate) {
      if (this.editForm.Dids) {
        this.editForm.Dids = this.editForm.Dids.replace(data.value + ",", "");
      } else {
        this.editForm.Dids = "";
      }
      if (checked) {
        this.editForm.Dids += data.value + ",";
      }
      console.log(data, checked, indeterminate);
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.CreateTime),
            "yyyy-MM-dd hh:mm:ss"
          );
    },
    formatPayTime: function (row, column) {
      return !row.PayTime || row.PayTime == ""
        ? ""
        : util.formatDate.format(new Date(row.PayTime), "yyyy-MM-dd hh:mm:ss");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getWxUser();
    },
    //获取订单列表
    getWxUser() {
      let _this = this;
      let para = {
        PageIndex: this.page,
        PageSize: this.pageSize,
        SearchValue: this.filters.name,
      };
      this.listLoading = true;
      //NProgress.start();
      GetWxUserInfo(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          DeleteWxUserInfo(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.currentRow = null; // Clear current row selection
              this.getWxUser();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);

      // 只有当核销权限为 true 时才获取场馆列表和订场列表
      if (this.editForm.GHKEnable) {
        this.getVenueList();
        // 如果有场馆ID，需要先获取订场列表，然后再设置订场值
        if (this.editForm.VenueId) {
          // 保存当前的 VenueCourtId
          const currentCourtId = this.editForm.VenueCourtId;

          // 获取订场列表并在完成后设置订场值
          GetVenueCourtListData({ Id: this.editForm.VenueId }).then((res) => {
            if (res.data.success) {
              this.courtOptions = res.data.response;
              // 等订场列表加载完成后，再设置订场值
              this.$nextTick(() => {
                this.editForm.VenueCourtId = currentCourtId;
              });
            }
          });
        }
      }
    },
    //显示新增界面
    handleAdd() {
      // this.addFormVisible = true;
      // this.options = [];
      // this.addForm = {
      //   CreateBy: "",
      //   Name: "",
      //   Enabled: true,
      //   AuthorityScope: -1,
      //   Dids: "",
      // };
      // let para = { pid: 0 };
      // getDepartmentTree(para).then((res) => {
      //   ++this.isResouceShow;
      //   this.options.push(res.data.response);
      // });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            PutWxUserInfo(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.currentRow = null;
                this.editFormVisible = false;
                this.getWxUser();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            if (this.$refs.treeAdd) {
              let pids = this.$refs.treeAdd.getCheckedKeys();
              para.Dids = pids.join(",");
            }

            addRole(para)
              .then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.addLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getWxUser();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                  this.addLoading = false;
                }
              })
              .catch((error) => {
                console.log("添加失败");
                this.$refs["addForm"].resetFields();
                this.addLoading = false;
                this.$message({
                  message: error.message || "添加角色失败，请重试",
                  type: "error",
                });
              });
          });
        }
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach((element) => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    },
    // 获取场馆列表
    getVenueList() {
      GetVenueDataList().then((res) => {
        if (res.data.success) {
          this.venueOptions = res.data.response;
        }
      });
    },

    // 场馆变化时获取对应的订场列表
    async handleVenueChange(venueId) {
      // 清空订场选项列表和选中值
      this.courtOptions = [];
      this.editForm.VenueCourtId = null;

      // 获取新场馆的订场列表
      if (venueId) {
        const res = await GetVenueCourtListData({ Id: venueId });
        if (res.data.success) {
          this.courtOptions = res.data.response;
        }
      }
    },
    handleCourtChange(VenueCourtId) {
      console.log("选择的订场:", VenueCourtId);
      console.log("当前订场选项:", this.courtOptions);
    },
    // 处理核销权限变化
    handleGHKEnableChange(value) {
      if (!value) {
        // 当关闭核销权限时，清空场馆和订场相关数据
        this.editForm.VenueId = null;
        this.editForm.VenueCourtId = null;
        this.venueOptions = [];
        this.courtOptions = [];
      } else {
        // 当开启核销权限时，获取场馆列表
        this.getVenueList();
      }
    },
  },
  mounted() {
    this.getWxUser();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

/* 添加自定义样式 */
.edit-dialog {
  /deep/ .el-dialog__body {
    padding: 20px 30px;
  }

  /deep/ .el-form-item {
    margin-bottom: 18px;
  }
}
</style>
